module.exports = __webpack_public_path__ + "img/korea.99de9fc8.png";